import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="onboarding--terms-modal"
export default class extends Controller {
  static targets = ["acceptTerms", "submitButton", "formsArea"];

  connect() {
    this.updateSubmitState();
  }

  updateSubmitState = () => {
    if (!this.hasSubmitButtonTarget || !this.hasAcceptTermsTarget) return;

    const canSubmit = this.acceptTermsTarget.checked;
    this.submitButtonTarget.disabled = !canSubmit;
    this.submitButtonTarget.classList.toggle("btn-disabled", !canSubmit);
  };

  handleSubmitEnd = (event) => {
    if (!event.detail.success) return;

    this.dispatch("accepted");
    if (this.hasFormsAreaTarget) {
      this.formsAreaTarget.classList.remove("opacity-50", "pointer-events-none");
    }
  };
}
